<template>
  <div class="input-group">
    <select
      :value="filterOperator"
      class="form-select"
      style="max-width: 120px"
      @change="onFilterOperatorChange($event.target.value)"
    >
      <option value="=">{{ $t('Equal to') }}</option>
      <option value="!=">{{ $t('Different from') }}</option>
      <option value="is_null">{{ $t('Is empty') }}</option>
      <option value="is_not_null">{{ $t('Is not empty') }}</option>
    </select>
    <multiselect
      :value="currentValue"
      :options="textListOptions"
      :multiple="field.isArray || false"
      :close-on-select="!field.isArray"
      :clear-on-select="false"
      :preserve-search="true"
      :preselect-first="false"
      :allow-empty="true"
      :searchable="true"
      :show-labels="true"
      :disabled="filterOperator === 'is_null' || filterOperator === 'is_not_null'"
      label="label"
      track-by="_id"
      :placeholder="placeholder || $t('Select an option')"
      class="mb-2"
      @input="onFilterValueChange"
    />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "FilterFieldTextList",
  components: {
    Multiselect,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Array, Object],
      default: null,
    },
    fieldId: {
      type: String,
      default: null,
    },
    filterOperator: {
      type: String,
      default: "=",
    },
  },
  computed: {
    textListOptions() {
      if (!this.field.options) return [];
      let optionsString = this.field.options;
      if (Array.isArray(optionsString)) {
        optionsString = optionsString[0];
      }
      const options = optionsString
        .split(/\s*[|,]\s*/)
        .map((option) => option.trim())
        .filter((option) => option);
      return options.map((option) => ({
        _id: option,
        label: this.$t(option),
      }));
    },
    currentValue() {
      if (this.value !== null && this.value !== undefined && this.value !== "") {
        return this.formatValue(this.value);
      }
      return null;
    },
    placeholder() {
      return this.field.label || this.field.key || "";
    },
    computedFieldId() {
      return this.fieldId || `filter-textlist-${this.field.key}`;
    },
  },
  methods: {
    formatValue(value) {
      if (value && typeof value === "object" && value._id && value.label) {
        return value;
      }
      if (Array.isArray(value)) {
        return value.map((item) => {
          if (typeof item === "object" && item._id) {
            return item;
          }
          return {
            _id: item,
            label: this.$t(item),
          };
        });
      }
      if (value !== null && value !== undefined && value !== "") {
        return {
          _id: value,
          label: this.$t(value),
        };
      }
      return null;
    },
    onFilterOperatorChange(operator) {
      this.$emit("filter-operator-change", operator);
    },
    onFilterValueChange(newValue) {
      let valueToEmit = newValue;
      if (Array.isArray(newValue)) {
        valueToEmit = newValue.map((item) =>
          typeof item === "object" && item._id ? item._id : item
        );
      } else if (newValue && typeof newValue === "object" && newValue._id) {
        valueToEmit = newValue._id;
      }
      this.$emit("input", valueToEmit);
    },
  },
};
</script>

<style scoped>
.input-group {
  width: 100%;
}

:deep(.multiselect-container) {
  position: relative;
  z-index: 1;
}

:deep(.multiselect.is-active) {
  z-index: 99999;
}

:deep(.multiselect__content-wrapper) {
  top: 100% !important;
  bottom: auto !important;
  transform: none !important;
  z-index: 99999 !important;
  position: absolute !important;
}

:deep(.multiselect__content) {
  max-height: 200px;
  overflow-y: auto;
}
</style>

